// extracted by mini-css-extract-plugin
module.exports = {"chip":"Chip_chip__2BN6z"};